import { useEffect, useState } from 'react';
import { ANNOTATOR_API } from '../api-handle';
import { LOCALSTORAGE_TOKEN_LABEL } from '../constants';

/**
 * useAllEventClasses hook:
 * it can be used to fetch all the event classes from the API server without
 * going into details of api calls
 */
export default function useAllEventClasses() {
  const [classes, setClasses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    ANNOTATOR_API.getAllEventClasses(
      window.localStorage.getItem(LOCALSTORAGE_TOKEN_LABEL)
    )
      .then((res) => {
        setClasses(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return { allEventClasses: classes, loadingAllEventClasses: isLoading };
}
